export const SET_OPTIONS = 'SET_OPTIONS';



// WEBPACK FOOTER //
// ./src/actions/types.js